module.exports = __webpack_public_path__ + "img/2w.d617f37f.svg";